import {
  Bar1,
  Bar2,
  Bar3,
  Bar4,
  Bar5,
  Bar6,
  Bar7,
  Bar8,
  Container,
  LoaderContainer,
} from './Loader.styles';

export const Loader = ({ ...props }) => (
  <Container {...props}>
    <LoaderContainer>
      <Bar1 />
      <Bar2 />
      <Bar3 />
      <Bar4 />
      <Bar5 />
      <Bar6 />
      <Bar7 />
      <Bar8 />
    </LoaderContainer>
  </Container>
);
